import React from "react";
import { FaArrowRight } from "react-icons/fa";

const ProjectCard = ({ project }) => {
  return (
    <article className="oglitz-project-card" aria-label={project.title}>
      {/* Image */}
      <div className="oglitz-project-image-wrap">
        <img src={project.image} alt={project.title} loading="lazy" />
      </div>

      {/* Content */}
      <div className="oglitz-project-body">
        <h3 className="oglitz-project-title">{project.title}</h3>
        <p className="oglitz-project-desc">{project.description}</p>

        <a
          href={project.link}
          target="_blank"
          rel="noopener noreferrer"
          className="oglitz-project-link"
        >
          View Project <FaArrowRight />
        </a>
      </div>
    </article>
  );
};

export default ProjectCard;
